import React from 'react';
import PropTypes from 'prop-types';
import shortId from 'shortid';
import { Table } from 'react-bootstrap';
import styles from './styles.css';


const ScrollableTablePanel = ({ columns, rows }) => (
  <div className={styles.panel}>
    <Table>
      <thead>
        <tr>
          { columns.map((column) => <th key={shortId.generate()}>{ column.label }</th>) }
        </tr>
      </thead>
      <tbody>
        { rows.map((row, rowIndex) => (
          <tr key={shortId.generate()} data-test-handle={`row-${rowIndex}`}>
            { columns.map((column) => <td key={shortId.generate()} data-test-handle={`${column.name}`}>{row[column.name]}</td>) }
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

ScrollableTablePanel.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  rows: PropTypes.array,
};

ScrollableTablePanel.defaultProps = {
  rows: [],
};


export default ScrollableTablePanel;



// WEBPACK FOOTER //
// ./src/components/ScrollableTablePanel/index.js